module.exports = __webpack_public_path__ + "static/img/linkedin-normal@2x.48b2786.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/social-simulation/linkedin-normal@2x.png
// module id = Bw1h
// module chunks = 1